import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f30a332a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f30a332a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30a332a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f30a332a')) {
      api.createRecord('f30a332a', component.options)
    } else {
      api.reload('f30a332a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f30a332a&scoped=true&", function () {
      api.rerender('f30a332a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8cHUXqhXUTdLA/JS/comp/PopupBox.vue"
export default component.exports